@if (value != null) {
  <span>
    {{ value | currency:currencyCode:displayFormat:digitsInfo }}
  </span>
}
